import React from "react";
import ProductCard from "../products/ProductCard";

function SectionHeaderTag({text, classes='', as=null}) {

    const defaultClasses = 'text-secondary fs-md-4 fw-bolder font-family-secondary my-0';

    if(text) {
        if(as) {
            return React.createElement(as, { className: `${defaultClasses} ${classes}`, style: { fontSize: '18px'} }, text);
        } else {
            return (
                <h2 className={`${defaultClasses}  ${classes}`} style={{fontSize: '18px'}}>{text}</h2>
            )
        }
    }
}

SectionHeaderTag.displayName = 'SectionHeaderTag';

export default SectionHeaderTag;